<template>
  <div>
    <p
      class="m-0 legends check-text-center color-blue font-bold"
      v-if="item.sameAdded == 1"
    >
      Este medicamento possui mais que uma frequência. Verifique as demais na
      prescrição.
    </p>
    <p class="m-0 worksansr legends check-text-center">
      Frequência:
      {{ handleFrequency(item.frequency) }}
    </p>
    <p
      class="m-0 worksansr legends check-text-center"
      v-if="item.frequency != 'EVENTUAL'"
    >
      Repetição:
      {{ handleEvery(item.every, item.frequency) }}
    </p>
    <p
      class="m-0 worksansr legends check-text-center"
      v-if="item.frequency == 'SEMANAL'"
    >
      Dias da semana:
      {{ item.dom && "DOM" }}
      {{ item.seg && "SEG" }}
      {{ item.ter && "TER" }}
      {{ item.qua && "QUA" }}
      {{ item.qui && "QUI" }}
      {{ item.sex && "SEX" }}
      {{ item.sab && "SAB" }}
    </p>
    <p
      class="m-0 worksansr legends check-text-center"
      v-if="item.medicine_amount_of_times_name"
    >
      Quantidade diária:
      {{ item.medicine_amount_of_times_name }}
    </p>
    <div
      class="d-flex flex-column"
      v-if="item.medicine_amount_of_times_type == 'SHIFTS'"
    >
      <div
        class="d-flex align-items-center"
        v-if="item.dawn && item.dawn_quantity"
      >
        MADRUGADA:
        <h6 class="m-0 ml-2 worksansr legends">
          {{
            item.drops_dawn_quantity
              ? `${item.drops_dawn_quantity} GOTA(S)`
              : item.ui_dawn_quantity
              ? `${item.ui_dawn_quantity} UI`
              : item.dawn_quantity
          }}
          {{
            item.drops_dawn_quantity
              ? ""
              : item.ui_dawn_quantity
              ? ""
              : `${item.unit_of_measurement_abbreviation} (S)`
          }}
        </h6>
      </div>
      <div
        class="d-flex align-items-center"
        v-if="item.morning && item.morning_quantity"
      >
        MANHÃ:
        <h6 class="m-0 ml-2 worksansr legends">
          {{
            item.drops_morning_quantity
              ? `${item.drops_morning_quantity} GOTA(S)`
              : item.ui_morning_quantity
              ? `${item.ui_morning_quantity} UI`
              : item.morning_quantity
          }}
          {{
            item.drops_morning_quantity
              ? ""
              : item.ui_morning_quantity
              ? ""
              : `${item.unit_of_measurement_abbreviation} (S)`
          }}
        </h6>
      </div>
      <div
        class="d-flex align-items-center"
        v-if="item.afternoon && item.afternoon_quantity"
      >
        TARDE:
        <h6 class="m-0 ml-2 worksansr legends">
          {{
            item.drops_afternoon_quantity
              ? `${item.drops_afternoon_quantity} GOTA(S)`
              : item.ui_afternoon_quantity
              ? `${item.ui_afternoon_quantity} UI`
              : item.afternoon_quantity
          }}
          {{
            item.drops_afternoon_quantity
              ? ""
              : item.ui_afternoon_quantity
              ? ""
              : `${item.unit_of_measurement_abbreviation} (S)`
          }}
        </h6>
      </div>
      <div
        class="d-flex align-items-center"
        v-if="item.night && item.night_quantity"
      >
        NOITE:
        <h6 class="m-0 ml-2 worksansr legends">
          {{
            item.drops_night_quantity
              ? `${item.drops_night_quantity} GOTA(S)`
              : item.ui_night_quantity
              ? `${item.ui_night_quantity} UI`
              : item.night_quantity
          }}
          {{
            item.drops_night_quantity
              ? ""
              : item.ui_night_quantity
              ? ""
              : `${item.unit_of_measurement_abbreviation} (S)`
          }}
        </h6>
      </div>
      <div
        class="d-flex align-items-center"
        v-if="item.shift_5 && item.shift_5_quantity"
      >
        5º:
        <h6 class="m-0 ml-2 worksansr legends">
          {{
            item.drops_shift_5_quantity
              ? `${item.drops_shift_5_quantity} GOTA(S)`
              : item.ui_shift_5_quantity
              ? `${item.ui_shift_5_quantity} UI`
              : item.shift_5_quantity
          }}
          {{
            item.drops_shift_5_quantity
              ? ""
              : item.ui_shift_5_quantity
              ? ""
              : `${item.unit_of_measurement_abbreviation} (S)`
          }}
        </h6>
      </div>
      <div
        class="d-flex align-items-center"
        v-if="item.shift_6 && item.shift_6_quantity"
      >
        6º:
        <h6 class="m-0 ml-2 worksansr legends">
          {{
            item.drops_shift_6_quantity
              ? `${item.drops_shift_6_quantity} GOTA(S)`
              : item.ui_shift_6_quantity
              ? `${item.ui_shift_6_quantity} UI`
              : item.shift_6_quantity
          }}
          {{
            item.drops_shift_6_quantity
              ? ""
              : item.ui_shift_6_quantity
              ? ""
              : `${item.unit_of_measurement_abbreviation} (S)`
          }}
        </h6>
      </div>
      <div
        class="d-flex align-items-center"
        v-if="item.shift_7 && item.shift_7_quantity"
      >
        7º:
        <h6 class="m-0 ml-2 worksansr legends">
          {{
            item.drops_shift_7_quantity
              ? `${item.drops_shift_7_quantity} GOTA(S)`
              : item.ui_shift_7_quantity
              ? `${item.ui_shift_7_quantity} UI`
              : item.shift_7_quantity
          }}
          {{
            item.drops_shift_7_quantity
              ? ""
              : item.ui_shift_7_quantity
              ? ""
              : `${item.unit_of_measurement_abbreviation} (S)`
          }}
        </h6>
      </div>
      <div
        class="d-flex align-items-center"
        v-if="item.shift_8 && item.shift_8_quantity"
      >
        8º:
        <h6 class="m-0 ml-2 worksansr legends">
          {{
            item.drops_shift_8_quantity
              ? `${item.drops_shift_8_quantity} GOTA(S)`
              : item.ui_shift_8_quantity
              ? `${item.ui_shift_8_quantity} UI`
              : item.shift_8_quantity
          }}
          {{
            item.drops_shift_8_quantity
              ? ""
              : item.ui_shift_8_quantity
              ? ""
              : `${item.unit_of_measurement_abbreviation} (S)`
          }}
        </h6>
      </div>
    </div>
    <p
      class="m-0 worksansr legends check-text-center"
      v-if="item.frequency != 'EVENTUAL'"
    >
      Duração:
      {{ handleDuration(item.duration) }}
    </p>
    <p
      class="m-0 worksansr legends check-text-center"
      v-if="
        item.medicine_amount_of_times_type == 'DAY' ||
        item.frequency == 'EVENTUAL'
      "
    >
      Quantidade:
      <span v-if="item.fractional_number">
        <span v-if="item.text_first_number" class="c-danger">
          {{ item.text_first_number }}
          <sup>{{ item.fractional_number }}</sup>
        </span>
        <span v-else class="c-danger">
          {{ item.fractional_number }}
        </span>
      </span>
      <span v-if="!item.fractional_number">
        {{
          item.drops_quantity
            ? `${item.drops_quantity} GOTA(S)`
            : item.ui_quantity
            ? `${item.ui_quantity} UI`
            : item.quantity
        }}
        {{
          item.drops_quantity
            ? ""
            : item.ui_quantity
            ? ""
            : `${item.unit_of_measurement_name} (S)`
        }}
      </span>
    </p>
    <p class="m-0 worksansr legends check-text-center" v-if="item.instruction">
      Instrução:
      {{ item.instruction }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Information",

  props: {
    item: { type: Object },
  },

  methods: {
    handleFrequency(frequency) {
      let frequencys = {
        DIARIO: "DIÁRIO",
        SEMANAL: "SEMANAL",
        MENSAL: "MENSAL",
        ANUAL: "ANUAL",
        EVENTUAL: "EVENTUAL",
        default: "NÃO ENCONTRADO!!!",
      };

      return frequencys[frequency] || frequencys.default;
    },
    handleEvery(every, frequency) {
      let frequencys = {
        DIARIO: "DIA",
        SEMANAL: "SEMANA",
        MENSAL: "MÊS",
        ANUAL: "ANO",
      };

      return `A CADA ${every} ${frequencys[frequency]}`;
    },
    handleDuration(duration) {
      let durations = {
        CONTINUO: "CONTÍNUO",
        DURANTE_UM_PERIODO: "DURANTE UM PERÍODO",
        ATE_A_DATA: "ATÉ A DATA",
        default: "EVENTUAL",
      };

      return durations[duration] || durations.default;
    },
  },
};
</script>
